module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-34.b255de2.woff2";